/* global google */

const MAP_CENTER_LAT = 52.15;
const MAP_CENTER_LON = 5.50;

const MAP_STYLE = [{featureType:"administrative.locality",elementType:"all",stylers:[{hue:"#2c2e33"},{saturation:7},{lightness:19},{visibility:"on"}]},{featureType:"landscape",elementType:"all",stylers:[{hue:"#ffffff"},{saturation:-100},{lightness:100},{visibility:"simplified"}]},{featureType:"poi",elementType:"all",stylers:[{hue:"#ffffff"},{saturation:-100},{lightness:100},{visibility:"off"}]},{featureType:"road",elementType:"geometry",stylers:[{hue:"#bbc0c4"},{saturation:-93},{lightness:31},{visibility:"simplified"}]},{featureType:"road",elementType:"labels",stylers:[{hue:"#bbc0c4"},{saturation:-93},{lightness:31},{visibility:"on"}]},{featureType:"road.arterial",elementType:"labels",stylers:[{hue:"#bbc0c4"},{saturation:-93},{lightness:-2},{visibility:"simplified"}]},{featureType:"road.local",elementType:"geometry",stylers:[{hue:"#e9ebed"},{saturation:-90},{lightness:-8},{visibility:"simplified"}]},{featureType:"transit",elementType:"all",stylers:[{hue:"#e9ebed"},{saturation:10},{lightness:69},{visibility:"on"}]},{featureType:"water",elementType:"all",stylers:[{hue:"#007fff"},{saturation:"-86"},{lightness:"-19"},{visibility:"simplified"}]}]; // eslint-disable-line

const LocationMap = {
  /**
   * Create element
   * @param {HTMLElement} node
   * @param {Object} props
   * @return {Void}
   */
  create(node, props) {
    this.items = window[props.locationMapItems];

    this.map = new google.maps.Map(node, {
      center: {
        lat: MAP_CENTER_LAT,
        lng: MAP_CENTER_LON,
      },
      zoom: 8,
      styles: MAP_STYLE,
    });

    this.addMarkers();
  },

  addMarkers() {
    this.items.forEach(this.addMarker.bind(this));
  },

  addMarker(item) {
    const shippingAddress = item.shipping_address;
    const { lat, lng } = shippingAddress.geo_code;

    const marker = new google.maps.Marker({
      position: { lat, lng },
      map: this.map,
    });

    const infowindow = new google.maps.InfoWindow({
      content: `
        <div class="location-map__info">
          <strong>${item.formatted_id}</strong><br>
          ${shippingAddress.street} ${shippingAddress.house_number}<br>
          ${shippingAddress.postal_code} ${shippingAddress.city}<br>
          ${shippingAddress.state ? shippingAddress.state : ''} ${shippingAddress.country}<br>

          <a href="${item.url}" class="btn btn-secondary" role="button">
            Bekijk order
          </a>
        </div>
      `,
    });

    marker.addListener('click', () => {
      infowindow.open(this.map, marker);
    });
  },
};

export default LocationMap;
